// extracted by mini-css-extract-plugin
export default {"main":"AdminAccount_main__0RAiP"};